<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-tv mr-2" />TV Commercial Group</h5>
            <hr />

            <b-row>
                <b-col md="12" class="text-right">
                    <b-button
                        class="mx-2"
                        variant="secondary"
                        @click="$bvModal.show('m-set-passcode')"
                    >
                        <i class="fa fa-key" /> Setting Password
                    </b-button>
                    <b-button
                        class="mx-2"
                        variant="success"
                        @click="openModalAddTVCGroup"
                    >
                        <i class="fa fa-plus mr-2" />Group Baru
                    </b-button>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="my-3"
            >
                <template v-slot:empty>
                    Tidak ada data group.
                </template>
                <template v-slot:cell(name)="row">
                    <div>
                        {{ row.item.name }}
                    </div>
                </template>
                <template v-slot:cell(active)="row">
                    <div>
                        {{ row.item.is_active == 1 ? "Aktif" : "Tidak Aktif" }}
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div>
                        <router-link :to="'tv-commercial/' + row.item.id">
                            <b-button
                                size="sm"
                                class="ml-2"
                                variant="primary"
                                v-b-tooltip.hover.top
                                title="TV Commercial Item"
                            >
                                <i class="fa fa-fw fa-info" />
                            </b-button>
                        </router-link>
                        <b-button
                            size="sm"
                            class="ml-2"
                            variant="warning"
                            v-b-tooltip.hover.top
                            title="Change Status"
                            @click="openModalChangeStatus(row.item)"
                        >
                            <i
                                v-if="row.item.is_active === 1"
                                class="fa fa-fw fa-toggle-on"
                            ></i>
                            <i v-else class="fa fa-fw fa-toggle-off"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
        <b-modal
            id="m-add-tvc-group"
            title="Add TVC Group"
            centered
            hide-footer
        >
            <div>
                <b-form-group label="Group Name">
                    <b-input v-model="input.name" />
                </b-form-group>
            </div>

            <b-row>
                <b-col md="12" class="text-right">
                    <b-button
                        variant="outline-primary"
                        class="mr-2"
                        :disabled="isSubmitting"
                        @click="addTVCGroup"
                    >
                        {{ isSubmitting ? "Menambahkan..." : "Tambah Group" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal
            id="m-change-status"
            title="Change Status Group"
            hide-footer
            centered
        >
            <p>Apakah anda yakin ingin mengubah status group ini?</p>
            <b-row>
                <b-col md="12" class="text-right">
                    <b-button
                        variant="outline-primary"
                        class="mr-2"
                        :disabled="isSubmitting"
                        @click="changeStatus"
                    >
                        {{ isSubmitting ? "Mengubah..." : "Ubah Status" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal id="m-set-passcode" title="Set Passcode" centered hide-footer>
            <div>
                <div>
                    <p class="font-weight-bold">Passcode saat ini : {{ currentPasscode }}</p>
                </div>
                <b-form-group label="Ganti Passcode">
                    <div class="input-group">
                        <b-input v-model="input.passcode" :type="showPassword" />
                        <div class="input-group-append">
                            <div
                                id="eye-icon"
                                class="eye-icon"
                                @click="togglePasscodeVisibility"
                            >
                                <i v-if="isPasscodeVisible" class="fa fa-eye"></i>
                                <i v-else class="fa fa-eye-slash"></i>
                            </div>
                        </div>
                    </div>
                </b-form-group>
            </div>
            <b-col md="12" class="text-right">
                <b-button
                    variant="outline-primary"
                    :disabled="isSubmitting"
                    @click="setPasscodeTVC"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Ganti Passcode" }}
                </b-button>
            </b-col>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: false,
            items: [],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            sortBy: null,
            sortDesc: false,
            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],
            fields: [
                { key: "name", label: "Group", sortable: true },
                { key: "active", label: "Status", sortable: true },
                { key: "action", label: "Aksi" }
            ],
            changeStatusData: {
                id: null,
                status: null
            },
            isSubmitting: false,
            input: {
                name: "",
                passcode: ""
            },
            isPasscodeVisible: false,
            currentPasscode: ""
        };
    },
    methods: {
        init() {
            this.initStatus = 0;

            Promise.all([this.getTVCGroups(), this.getPasscodeTVC()])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(() => {
                    this.initStatus = -1;
                });
        },
        getTVCGroups(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            this.$axios
                .get("sm-tvc/groups" + param)
                .then(res => {
                    const { items, total } = res.data.data;
                    this.items = items;
                    this.totalRows = total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        getPasscodeTVC() {
            this.$axios
                .get("sm-tvc/passcode")
                .then(res => {
                    this.currentPasscode = res.data.data.value;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
        },

        changeStatus() {
            this.isSubmitting = true;
            this.$axios
                .patch(`sm-tvc/groups/${this.changeStatusData.id}/status`, { is_active: !this.changeStatusData.status })
                .then(_ => {
                    this.$helper.toastSuccess(this, "Status berhasil diubah!");
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isSubmitting = false;
                    this.$bvModal.hide("m-change-status");
                    this.getTVCGroups();
                });
        },

        addTVCGroup() {
            this.isSubmitting = true;

            const payload = {
                name: this.input.name
            };

            this.$axios
                .post("sm-tvc/groups", payload)
                .then(_ => {
                    this.$helper.toastSuccess(
                        this,
                        "Group berhasil ditambahkan!"
                    );
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isSubmitting = false;
                    this.getTVCGroups();
                    this.$bvModal.hide("m-add-tvc-group");
                });
        },

        setPasscodeTVC() {
            this.isSubmitting = true;

            const payload = {
                passcode: this.input.passcode
            };

            this.$axios
                .patch("sm-tvc/passcode", payload)
                .then(_ => {
                    this.$helper.toastSuccess(this, "Passcode berhasil diset!");
                    this.getPasscodeTVC();
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isSubmitting = false;
                    this.$bvModal.hide("m-set-passcode");
                    this.input.passcode = "";
                });
        },

        openModalAddTVCGroup() {
            this.$bvModal.show("m-add-tvc-group");
        },

        openModalChangeStatus(item) {
            this.changeStatusData.id = item.id;
            this.changeStatusData.status = item.is_active;
            this.$bvModal.show("m-change-status");
        },
        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getTVCGroups();
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getTVCGroups(this.currentPage);
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getTVCGroups(this.currentPage);
        },
        togglePasscodeVisibility() {
            this.isPasscodeVisible = !this.isPasscodeVisible;
        }
    },
    computed: {
        showPassword() {
            return this.isPasscodeVisible ? "text" : "password";
        }
    },
    created() {
        this.init();
    }
};
</script>

<style scoped>

.input-group {
    position: relative;
}

.input-group-append {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 999;
}

.eye-icon {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.eye-icon i {
    font-size: 18px;
}
</style>
